<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- Dynamic Menus -->
      <li class="nav-item" v-for="(menu, n) in menus" :key="n">
        <sidenav-item
          :url="'/'+menu.path"
          :class="getRoute() === menu.path ? 'active' : ''"
          :navText="menu.nombre"
        >
          <template v-slot:icon>
            <i :class="menu.icon + ' text-sm opacity-10'"></i>
          </template>
        </sidenav-item>
      </li>
      <li><hr></li>
    </ul>
  </div>

  <Toast />
  <Dialog v-model:visible="reset.visible" modal :style="{ width: '40%' }" :breakpoints="{ '1199px': '65vw', '375px': '80vw' }"
  :pt="{ root: 'border-none', mask: { style: 'backdrop-filter: blur(4px)' } }" v-if="user != null">
    <template #header>
      <div class="justify-content-center">
          <h4 class="font-bold">{{user.persona.nombres + ' ' + user.persona.apellidos}}</h4>
      </div>
    </template>
    <span class="p-text-secondary block mb-5">Actualiza tu información.</span>
    <div class="row">
      <div class="col-md-12">
          <label for="password">Ingrese su contraseña nueva <span class="text-danger">*</span></label>
          <Password v-model="reset.password" toggleMask class="w-100"
            promptLabel="Eliga una contraseña" weakLabel="Muy simple" mediumLabel="Complejidad Media" strongLabel="Contraseña Compleja"
          >
            <template #header>
                <h6>Eliga una contraseña</h6>
                <b>La contraseña debe contener mínimamente 8 caracteres</b>
            </template>
            <template #footer>
                <p class="mt-2">Sugerencias</p>
                <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                    <li>Al menos una minúscula</li>
                    <li>Al menos una mayúscula</li>
                    <li>Al menos un número</li>
                    <!-- <li><b>Mínimamente 8 caracteres</b></li> -->
                </ul>
            </template>
        </Password>
        <InlineMessage severity="error" v-if="valueIsValid(reset.password) && reset.password.length < 8">La contraseña debe contener mínimamente 8 caracteres</InlineMessage>
      </div>
      <div class="col-md-12 pt-4">
        <label for="re-password">Confirme su contraseña nueva <span class="text-danger">*</span></label>
        <Password v-model="reset.rePassword" toggleMask class="w-100" :feedback="false"/>
        <InlineMessage severity="error" v-if="valueIsValid(reset.rePassword) && !resetIsValid">Las contraseñas no coinciden</InlineMessage>
      </div>
    </div>
    <template #footer>
        <button class="btn btn-addiuva-dark" :disabled="!resetIsValid" @click="resetPassword">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
    </template>
  </Dialog>
</template>
<script>
import { mapMutations } from "vuex";
import SidenavItem from "./SidenavItem.vue";
import Dialog from 'primevue/dialog';
import Password from 'primevue/password';
import InlineMessage from 'primevue/inlinemessage';
import axios from 'axios';
import authHeader from '../../services/auth-header';
import Toast from 'primevue/toast';
import {useDevice} from '../../services/useDevice';

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Dashboard",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
      user: null,
      reset: {
        visible: false,
        password: null,
        rePassword: null
      },
      menus: {},
      device: useDevice().isMobile,
    };
  },
  components: {
    SidenavItem,
    Dialog,
    Password,
    InlineMessage,
    Toast
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    this.getUserDetail();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  watch: {
    getProfileMe(value) {
      this.menus = value.data.menu;
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize"]),
    handleOutsideClick(event) {
      // Solo cerrar si está abierto y el click no fue dentro del menú
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (
        !event.target.classList.contains('sidenav-toggler-inner') &&
        !event.target.classList.contains('sidenav-toggler-line') &&
        !sidenav_show.classList.contains("g-sidenav-hidden") &&
        this.device
      ) {
        this.navbarMinimize();
      }
    },
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },
    valueIsValid: function(value) {
      return (value !== null && value !== "" && value !== 0 && value !== [] && (typeof value !== "undefined"));
    },
    getUserDetail() {
      // console.log('getUserDetail');
      /*let profile = this.getProfileMe;
      if (profile == null &&  Object.keys(authHeader()).length !== 0) {
        let url = process.env.VUE_APP_API_BASE_URL + "/userDetail";
        axios({
          url: url,
          method: 'post',
          data: {},
          headers: authHeader(),
        })
        .then(response => {
          if (response.data.status) {
            this.user = response.data.data;
            this.menus = response.data.data.menu
            if (!this.user.logueado) {
              this.reset = {
                visible: true,
                password: null,
                rePassword: null
              };
            }
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      }
      if (profile != null) {
        this.menus = profile.data.menu;
      }*/
    },
    resetPassword() {
      if (this.user.id_usuario == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.user.persona.nombres,
            "apellidos": this.user.persona.apellidos,
            "fecha_nacimiento": this.user.persona.fecha_nacimiento,
            "numero_documento": this.user.persona.numero_documento,
            "telefono": this.user.persona.telefono,
            "email": this.user.persona.email,
        },
        "password": this.reset.password,
        "activo": true,
        "logueado": true,
        "id_agencia": this.user.id_agencia,
        "id_rol": this.user.id_rol,
      }
      // Send Data by Axios
      let url = process.env.VUE_APP_API_BASE_URL + "/usuarios/" + this.user.id_usuario;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Su nueva contraseña fue guardada exitosamente', life: 3000 });
            this.closeModal();
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    closeModal() {
      this.reset = {
        visible: false,
        password: null,
        rePassword: null
      }
    }
  },
  computed: {
    resetIsValid() {
      return (this.valueIsValid(this.reset.password) && this.reset.password == this.reset.rePassword) ? true : false;
    },
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  }
};
</script>
<style>
.p-dialog-header-close {
  display: none;
}
.p-password-input {
  width: 100%;
}
.p-hidden-accessible {
  display: none !important;
}
</style>
